import { AsideNav } from './asideNav'
import { BottomNavHorizonal } from './bottomNavHorizonal'
import { Modal, ShareModalProps } from './modal'

const _SharePopupNew = ({ ...rest }: ShareModalProps) => {
  return <Modal {...rest} />
}

interface CompoundedComponent
  extends React.ForwardRefExoticComponent<ShareModalProps> {
  Modal: typeof Modal
  AsideNav: typeof AsideNav
  BottomNavHorizonal: typeof BottomNavHorizonal
}

const SharePopupNew = (_SharePopupNew as unknown) as CompoundedComponent

SharePopupNew.Modal = Modal
SharePopupNew.AsideNav = AsideNav
SharePopupNew.BottomNavHorizonal = BottomNavHorizonal

export { SharePopupNew }
